<template>
  <div class="nft-btnbar" :id="'nft-btnbar-'+position">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ButtonBar',
    props: {
      position: {
        type: String,
        default: "top",
      }
    }
  }
</script>

<style lang="scss">
  .nft-btnbar {
    position: sticky;
    position: -webkit-sticky;
    pointer-events: all;
  }

  #nft-btnbar-top {
    top: $spacer;
    margin-top: $navbar-height + $spacer;
  }

  #nft-btnbar-bottom {
    bottom: 0;
    padding-bottom: 1rem;
  }
</style>